module.exports = __webpack_public_path__ + "img/jiangxin.e698c5d4.png";